import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  font-weight: 600px;
  align-items: center;
  color: ${props => props.theme.color.searchGrey};
`;

export default Wrapper;